import axios from "axios";

const createApiClient = (baseURL, includeToken = true) => {
  const api = axios.create({
    baseURL: baseURL || process.env.REACT_APP_API_URL || "http://localhost:8080/",
  });

  api.interceptors.request.use((config) => {
    if (includeToken) {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  });

  return api;
};

export default createApiClient;
